// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_haveAccount__TQLQk {
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: auto;
  display: flex;
  margin-top: 14px;
  margin-bottom: 40px;
}

.styles_inputContainer__d5LVy {
  margin-bottom: 30px;
  width: 100%;
}

.styles_wrapper__fEtGT {
  width: 100%;
}

.styles_active__vLDQN {
  background: none;
  color: #d8000d;
  cursor: pointer;
}

.styles_unActive__jV8Fg {
  background: none;
  color: #c5c5c5 !important;
}

.styles_formButton__Wx4zZ {
  width: 100% !important;
}

.styles_formButton__Wx4zZ > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 10px !important;
}

.styles_flexStyle__CDIbb {
  flex-direction: row;
  margin-top: 40px;
  border-radius: 10px;
  height: auto;
  width: auto !important;
}

@media only screen and (max-width: 1024px) {
  .styles_flexStyle__CDIbb {
    flex-direction: column;
  }
  .styles_flexStyle__CDIbb > div:nth-child(2) {
    margin: 0 auto;
    margin-top: 20px;
  }
  .styles_formContainer__Yf-yO {
    border-left-width: 0px;
  }
}
@media only screen and (max-width: 800px) {
  .styles_force_media__jQa\\+j {
    padding: 0 10px 0 10px !important;
  }
  .styles_flexStyle__CDIbb {
    flex-direction: column-reverse;
    overflow: auto;
    padding-bottom: 20px;
    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_flexStyle__CDIbb::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .styles_flexStyle__CDIbb::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
  .styles_flexStyle__CDIbb > div:nth-child(2) {
    margin: 0;
    margin-top: 20px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SignUpCode/styles.module.scss"],"names":[],"mappings":"AAMA;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAOA;EACE,mBAAA;EACA,WAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAMA;EACE,gBAAA;EAEA,cAAA;EACA,eAAA;AAJF;;AAOA;EACE,gBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAMA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,mBAAA;EACA,gBAAA;EAEA,mBAAA;EAGF,YAAA;EACA,sBAAA;AANA;;AAUA;EACE;IACE,sBAAA;EAPF;EAUA;IACE,cAAA;IACA,gBAAA;EARF;EAUA;IACE,sBAAA;EARF;AACF;AAYA;EACE;IACE,iCAAA;EAVF;EAYA;IACE,8BAAA;IACA,cAAA;IAEA,oBAAA;IAGA,oCAAA;IACA,oBAAA;EAbF;EAeA;IAEE,uBAAA;IACA,UAAA;EAdF;EAiBA;IACE,yBAAA;IACA,oBAAA;IACA,WAAA;EAfF;EAkBA;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;IACA,qBAAA;EAhBF;AACF","sourcesContent":["// @use '@/form_core.scss';\n.container {\n  // padding-left: 1.5rem;\n  // padding-right: 1.5rem;\n}\n\n.haveAccount {\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  width: auto;\n  display: flex;\n  margin-top: 14px;\n  margin-bottom: 40px;\n}\n.inputContainer{\n  margin-bottom:30px;\n  width:100%;\n\n}\n.wrapper{\n  width:100%;\n}\n.active {\n  background: none;\n\n  color: #d8000d;\n  cursor: pointer;\n}\n\n.unActive {\n  background: none;\n  color: #c5c5c5 !important;\n}\n\n.formButton{\n  width:100% !important;\n}\n.formButton>button{\n  width:100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-top:10px !important;\n}\n\n.flexStyle {\n  flex-direction: row;\n  margin-top:40px;\n\n  border-radius: 10px;\n// border: 1px solid rgba(0, 0, 0, 0.50);\n// background: #FFF;\nheight:auto;\nwidth:auto !important;\n}\n\n\n@media only screen and (max-width: 1024px) {\n  .flexStyle {\n    flex-direction: column;\n  }\n\n  .flexStyle > div:nth-child(2) {\n    margin: 0 auto;\n    margin-top: 20px;\n  }\n  .formContainer {\n    border-left-width: 0px;\n  }\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n  .force_media {\n    padding: 0 10px 0 10px !important;\n  }\n  .flexStyle {\n    flex-direction: column-reverse;\n    overflow: auto;\n    // height: calc( 100vh - 138px);\n    padding-bottom: 20px;\n  \n\n    scrollbar-color: #e3e3e3 transparent;\n    scrollbar-width: 8px;\n  }\n  .flexStyle::-webkit-scrollbar {\n  \n    background: transparent;\n    width: 8px;\n  }\n  \n  .flexStyle::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 8px;\n  }\n\n  .flexStyle > div:nth-child(2) {\n    margin: 0;\n    margin-top: 20px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"haveAccount": `styles_haveAccount__TQLQk`,
	"inputContainer": `styles_inputContainer__d5LVy`,
	"wrapper": `styles_wrapper__fEtGT`,
	"active": `styles_active__vLDQN`,
	"unActive": `styles_unActive__jV8Fg`,
	"formButton": `styles_formButton__Wx4zZ`,
	"flexStyle": `styles_flexStyle__CDIbb`,
	"formContainer": `styles_formContainer__Yf-yO`,
	"force_media": `styles_force_media__jQa+j`
};
export default ___CSS_LOADER_EXPORT___;
